/**
 * Revision History
 * 
 * 12/01/2021 ptkim       Add appendLine
 */
import _ from 'lodash';
import {History} from 'history';
import React from 'react';

import constants from '../constants';
import {getCurrencies, getFmsGlobal} from '../globals';

import {BillInvoiceLineItem, CompanyPreview } from '../ifmsTypes';
import {round as mathRound} from 'mathjs';
import {InvoDetail} from "../fms.core/InvoDetail";
import {ApDetail} from "../fms.core/ApDetail";
import { IfmsConfigMenuItem } from '../config/types';
import { SecurityGrant } from '../framework.core/SecurityGrant';
import { FmsSecTask } from '../fms.core/constants';
import { JobNames } from '../framework.core/JobNames';
import { SecType } from '../fms.enum';
import { IApplicationContext } from '../ApplicationContext';

import { OiMblListItem } from '../fms.data/models/OiMblListItem';
import { OiHblListItem } from '../fms.data/models/OiHblListItem';
import { AiMblListItem } from '../fms.data/models/AiMblListItem';
import { AiHblListItem } from '../fms.data/models/AiHblListItem';
import { OeMblListItem } from '../fms.data/models/OeMblListItem';
import { OeHblListItem } from '../fms.data/models/OeHblListItem';
import { AeMblListItem } from '../fms.data/models/AeMblListItem';
import { AeHblListItem } from '../fms.data/models/AeHblListItem';
import { OtherOperationListItem } from '../fms.data/models/OtherOperationListItem';
import { WhReciptsListItem } from '../fms.data/models/WhReciptsListItem';
import { WhRcvListItem } from '../fms.data/models/WhRcvListItem';
import { WhShipListItem } from '../fms.data/models/WhShipListItem';
import { CodeCompanyListItem } from '../fms.data/models/CodeCompanyListItem';
import { PimsBookingListItem } from '../fms.data/models/PimsBookingListItem';
import { PimsVanningListItem } from '../fms.data/models/PimsVanningListItem';
import { OeBookingListItem } from '../fms.data/models/OeBookingListItem';
import { BillPaymentListItem } from '../fms.data/models/BillPaymentListItem';
import { BatchRecogListItem } from '../fms.data/models/BatchRecogListItem';
import { InvoiceListItem } from '../fms.data/models/InvoiceListItem';
import { BillListItem } from '../fms.data/models/BillListItem';
import { CrDbListItem } from '../fms.data/models/CrDbListItem';
import { JournalLedgerListItem } from '../fms.data/models/JournalLedgerListItem';
import { BTOrderListItem } from '../fms.data/models/BTOrderListItem';
import { BTLoadPlanListItem } from '../fms.data/models/BTLoadPlanListItem';
import { BTLocalDOListItem } from '../fms.data/models/BTLocalDOListItem';
import { MyEventListItem } from '../fms.data/models/MyEventListItem';
import { IsfListItem } from '../fms.data/models/IsfListItem';
import { OrchidBaroListItem } from '../fms.data/models/OrchidBaroListItem';
import { AmsMasterListItem } from '../fms.data/models/AmsMasterListItem';
import { AmsVoyageListItem } from '../fms.data/models/AmsVoyageListItem';
import { AmsHouseListItem } from '../fms.data/models/AmsHouseListItem';
import { AmsUserListItem } from '../fms.data/models/AmsUserListItem';
import { AmsBranchListItem } from '../fms.data/models/AmsBranchListItem';
import { AmsHistoryListItem } from '../fms.data/models/AmsHistoryListItem';
import { AmsBillingCodeListItem } from '../fms.data/models/AmsBillingCodeListItem';
import { Ams1CHistoryListItem } from '../fms.data/models/Ams1CHistoryListItem';

interface IndexByString {
  [key: string]: string,
};

const operations: IndexByString = {
  home: 'Home',
  order: 'Manifest',
  load: 'Load',
  localDO: 'Local D/O',
  warehousing: 'Warehouse',     //Change name Warehousing -> Warehouse
  opReport: 'Operation Report',  
  billings: 'Billings',
  accounting: 'Accounting',
  customer: 'Customer List',
  utility: 'Util',
  businessIntell: 'Business Intelligence',
  standalone: 'Standalone',
  orchidBaro: 'Orchid Baaro',
  ams: 'AMS',
  isf: 'ISF',


}

export const OperationsMap = _.map(operations, (value, key) => ({
  key,
  value,
}));

/**
 * @deprecated - Utility function to get layout sizes based on browser size.
 * It was used in old 'responsive' design
 *
 * @export
 * @param {number} viewportWidth - browser width
 */
 export const getLayoutSizes = (viewportWidth:number) => {
  if (viewportWidth < 1360) {
    return constants.layout.break4;
  }
  else if (viewportWidth < 1440) {
    return constants.layout.break3;
  }
  else if (viewportWidth < 1680) {
    return constants.layout.break2;
  }
  else if (viewportWidth < 1920) {
    return constants.layout.break1;
  } else {
    return constants.layout.large;
  }
}


/**
 * Utility function to get operation key from name.
 * ocean Import -> oceanImport return.
 *
 * @export
 * @param {string} operationName
 * @return {*}  {(string|null)}
 */
export function getOperationKey(operationName:string):string|null {
  const match = OperationsMap.find(x => x.value === operationName);
  return match ? match.key : null;
}

/**
 * to get Opertaion Name from JobName 
 * OIMB or OIHB > Ocean Import return.
 * @param parent 
 * @returns 
 */
export function getOperationNameFromJobName(jobName: JobNames): string {
  if (jobName === JobNames.OIHbl || jobName === JobNames.OIMbl) {
    return constants.operations.oceanImport;
  } else if (jobName === JobNames.OEHbl || jobName === JobNames.OEMbl) {
    return constants.operations.oceanExport;
  } else if (jobName === JobNames.AIHbl || jobName === JobNames.AIMbl) {
    return constants.operations.airImport;
  } else if (jobName === JobNames.AEHbl || jobName === JobNames.AEMbl) {
    return constants.operations.airExport;
  } else if (jobName === JobNames.OtherOP) {
    return constants.operations.otherShipment;
  } else if (jobName === JobNames.WHRcv || jobName === JobNames.WHShip) {
    return constants.operations.warehousing;
  } else if (jobName === JobNames.BTOrder) {
    return constants.operations.order;
  } else if (jobName === JobNames.BTLoadPlan) {
    return constants.operations.load;
  } else if (jobName === JobNames.BTDo) {
    return constants.operations.localDO;
  } else if (jobName === JobNames.OrchidBaro){
    return constants.operations.orchidBaro;
  }

  throw new Error('Unexpected parent type');
}


/**
 * Utility function to check if str1 contains str2 - ignore case
 *
 * @export
 * @param {(string|null|undefined)} str1
 * @param {(string|null|undefined)} str2
 * @return {*} 
 */
export function stringsContainsIgnoreCase(str1:string|null|undefined, str2:string|null|undefined) {
  if (str1 === null || str1 === undefined || str1 === '' || str2 === null || str2 === undefined || str2 === '') {
    return false;
  }

  return str1.toLowerCase().includes(str2.toLowerCase());
}

/**
 * Utility function to check if str1 equals str2 - ignore case
 *
 * @export
 * @param {(string|null|undefined)} str1
 * @param {(string|null|undefined)} str2
 * @return {*} 
 */
export function stringsEqualIgnoreCase(str1:string|null|undefined, str2:string|null|undefined) {
  if (str1 === null) {
    return str2 === null;
  }
  if (str1 === undefined) {
    return str2 === undefined;
  }
  if (str2 === null) {
    return str1 === null;
  }
  if (str2 === undefined) {
    return str1 === undefined;
  }

  return str1.toLowerCase() === str2.toLowerCase();
}

/**
 * Utility function to check if str1 starts with str2 - ignore case
 *
 * @export
 * @param {(string|null|undefined)} str1
 * @param {(string|null|undefined)} str2
 * @return {*} 
 */
export function stringsStartsWithIgnoreCase(str1:string|null|undefined, str2:string|null|undefined) {
  if (str1 === null || str2 === null || str1 === undefined || str2 === undefined) {
    return false;
  }

  return str1.toLowerCase().startsWith(str2.toLowerCase());
}

/**
 * Convert length, width, height to kgs and lbs
 *
 * @export
 * @return {*}
 * @param calculation
 */
export function dimensionsToKgsLbs({length, width, height, pcs, volCm}: {
  length: number,
  width: number,
  height: number,
  pcs: number,
  volCm: boolean
}) {

  const weightCalculationBase = (length ?? 0) * (width ?? 0) * (height ?? 0) * (pcs ?? 0);

  const change = {chgWeight: 0, lChgWeight: 0}

  if (weightCalculationBase > 0) {
    if (volCm) {
      change.chgWeight = mathRound(weightCalculationBase / 6000.0, 2);
      change.lChgWeight = mathRound(kgToLbs(change.chgWeight) ?? 0, 2);
    } else {
      change.lChgWeight = mathRound(weightCalculationBase/166.0, 2);
      change.chgWeight = lbsToKg(change.lChgWeight) ?? 0;
    }
  }

  return change;
}

/**
 * Convert length, width, height to cbm and lbs
 *
 * @export
 * @return {*}
 * @param calculation
 * @param includeLbs
 */
export function dimensionsToCbmKgs({length, width, height, pcs, volCm}: {
  length: number,
  width: number,
  height: number,
  pcs: number,
  volCm: boolean
}, includeLbs = false): {chgWeight: number, lChgWeight?: number} {

  const weightCalculationBase = (length ?? 0) * (width ?? 0) * (height ?? 0) * (pcs ?? 0);

  const change = {chgWeight: 0, lChgWeight: 0}

  if (weightCalculationBase > 0) {
    if (volCm) {
      change.chgWeight = mathRound(weightCalculationBase/1000000, 3);
      if(includeLbs) {
        change.lChgWeight = mathRound(weightCalculationBase/6000 * 2.2046, 2);
      }
    } else {
      change.chgWeight = mathRound((weightCalculationBase / 1728) / 35.3147, 3);
      if(includeLbs) {
        change.lChgWeight = mathRound(weightCalculationBase/166.0, 2);
      }
    }
  }
  if(!includeLbs) {
    return {chgWeight: change.chgWeight}
  }
  return change;
}

/**
 * Convert kg to lbs
 *
 * @export
 * @param {(number|null|undefined)} n
 * @return {*} 
 */
export function kgToLbs(n:number|null|undefined) {
  if (n === null || n === undefined || isNaN(n)) {
    return null;
  }

  return n * 2.2046;
}

/**
 * Convert lbs to kg
 *
 * @export
 * @param {(number|null|undefined)} n
 * @return {*} 
 */
export function lbsToKg(n:number|null|undefined) {
  if (n === null || n === undefined || isNaN(n)) {
    return null;
  }

  return Math.round(n / 2.2046 * 100) / 100;
}

/**
 * Convert CFT to CBM
 *
 * @export
 * @param {(number|null|undefined)} n
 * @return {*} 
 */
export function cftToCbm(n:number|null|undefined) {
  if (n === null || n === undefined || isNaN(n)) {
    return null;
  }

  return n / 35.3147;
}

/**
 * Check if keyboard event is key press (not function or special key)
 *
 * @export
 * @param {KeyboardEvent} evt
 * @return {*} 
 */
export function isCharacterKeyPress(evt:KeyboardEvent|React.KeyboardEvent) {
  return (!evt.keyCode) ||
    (
      !(evt.keyCode <= 29 ) &&
      !(evt.keyCode >= 33 && evt.keyCode <= 47) &&
      !(evt.keyCode >= 91 && evt.keyCode <= 95) &&
      !(evt.keyCode >= 112 && evt.keyCode <= 151) &&
      !(evt.keyCode >= 166 && evt.keyCode <= 169) &&
      !(evt.keyCode >= 172 && evt.keyCode <= 183) &&
      !(evt.keyCode >= 224 && evt.keyCode <= 235)
    );
}

/**
 * Round number to 3 decimal places
 *
 * @export
 * @param {(number|null|undefined)} n
 * @return {*} 
 */
export function round(n:number|null|undefined) {
  if (n === null || n === undefined) {
    return n;
  }

  return Math.round(n * 10000) / 10000;
}

/**
 * Utility function to process Bill or Invoice line item delete. It makes sure that if line item with extra currency has been deleted
 * unused currencies and exchange rates are deleted
 *
 */

export function handleBillOrInvoiceLineItemDelete(
  cur1Param:string|null|undefined,
  cur2Param:string|null|undefined,
  exRate1Param:number|null|undefined,
  exRate2Param:number|null|undefined,
  lineItems:Array<BillInvoiceLineItem>
):{
  cur1: string,
  cur2: string,
  exRate1: number|null,
  exRate2: number|null,
} {
  let cur1 = cur1Param ?? '';
  let cur2 = cur2Param ?? '';
  let exRate1 = exRate1Param ?? null;
  let exRate2 = exRate2Param ?? null;

  if (cur2) {
    const used = lineItems.some(x => x.cur === cur2 || x.agtCur === cur2);
    if (!used) {
      cur2 = '';
      exRate2 = null;
    }
  }

  if (cur1) {
    const used = lineItems.some(x => x.cur === cur1 || x.agtCur === cur1);
    if (!used) {
      cur1 = '';
      exRate1 = null;

      // if cur 2 is used - move it to cur1
      if (cur2) {
        cur1 = cur2;
        exRate1 = exRate2;
        cur2 = '';
        exRate2 = null;
      }
    }
  }

  return {cur1, cur2, exRate1, exRate2};
}
/**
 * Utility function to process Bill or Invoice currency change. It keeps track of all currencies in line items to make sure max 3 currencies are used
 * After analyzing all line items it returns which are the currencies in use, which is currency 1 and 2 and matching exchange rate
 * In case currency 1 is removed (not used any more) it moves currency 2 to currency 1
 *
 * @export
 * @param {(string|null|undefined)} newCur
 * @param {(string|null|undefined)} oldCur
 * @param {Array<string>} availableCurrenciesParam
 * @param {(string|null|undefined)} cur1Param
 * @param {(string|null|undefined)} cur2Param
 * @param {(number|null|undefined)} exRate1Param
 * @param {(number|null|undefined)} exRate2Param
 * @param {(string|null|undefined)} primaryCurrency
 * @param {Array<BillInvoiceLineItem>} lineItems
 * @return {*} 
 */
export function handleBillOrInvoiceCurrencyChange(
  newCur:string|null|undefined,
  oldCur:string|null|undefined,
  availableCurrenciesParam:Array<string>,
  cur1Param:string|null|undefined,
  cur2Param:string|null|undefined,
  exRate1Param:number|null|undefined,
  exRate2Param:number|null|undefined,
  primaryCurrency:string|null|undefined,
  lineItems:Array<BillInvoiceLineItem|InvoDetail|ApDetail>) {
  let cur = newCur;
  let cur1 = cur1Param;
  let cur2 = cur2Param;
  let exRate1 = exRate1Param;
  let exRate2 = exRate2Param;
  let availableCurrencies = availableCurrenciesParam;

  if (!!oldCur && oldCur !== primaryCurrency) {
    const othersUseOldCurrency = lineItems.some(
      x => x.cur === oldCur || (x as BillInvoiceLineItem)?.agtCur === oldCur || (x as InvoDetail)?.agtCur === oldCur
    );
    if (!othersUseOldCurrency) {
      availableCurrencies = availableCurrencies.filter(x => x !== oldCur);
      if (cur1 === oldCur) {
        cur1 = cur2;
        exRate1 = exRate2;
        cur2 = null;
        exRate2 = 0;
      }
      if (cur2 === oldCur) {
        cur2 = null;
        exRate2 = 0;
      }
    }
  }

  if (!!newCur && newCur !== primaryCurrency) {
    if (!availableCurrencies.some(x => x === newCur)) {
      availableCurrencies.push(newCur);
    }

    if (cur1 !== newCur && cur2 !== newCur) {
      if (_.isEmpty(cur1)) {
        cur1 = newCur;
        exRate1 = 0;
      } else {
        cur2 = newCur;
        exRate2 = 0;
      }
    }
  }

  return { currency: cur ?? '', invCur1: cur1 ?? '', invCur2: cur2 ?? '', exRate1: exRate1 || 0, exRate2: exRate2 || 0, availableCurrencies };
}

function applyLineItemCurrencyChange(l:BillInvoiceLineItem, cur:string|null|undefined) {
  l.cur = cur ?? '';
  return l;
  // const r = _.cloneDeep(l);
  // r.cur = cur ?? '';
  // return r;
}

function applyLineItemAgentCurrencyChange(l:BillInvoiceLineItem, agentCur:string|null|undefined) {
  l.agtCur = agentCur ?? '';
  return l;
  // const r = _.cloneDeep(l);
  // r.agentCur = agentCur ?? '';
  // return r;
}

type BicChangeFunction = (x:BillInvoiceLineItem, c:string|null|undefined) => BillInvoiceLineItem;

function billOrInvoiceCurrencyChangeWorker(
  cur:string|null|undefined,
  newCur:string|null|undefined,
  oldCur:string|null|undefined,
  i:number,
  availableCurrenciesParam:Array<string>,
  cur1Param:string|null|undefined,
  cur2Param:string|null|undefined,
  exRate1Param:number|null|undefined,
  exRate2Param:number|null|undefined,
  primaryCurrency:string|null|undefined,
  lineItemsParam:Array<BillInvoiceLineItem>,
  curChangeFnc: BicChangeFunction
) {
  let cur1 = cur1Param;
  let cur2 = cur2Param;
  let exRate1 = exRate1Param;
  let exRate2 = exRate2Param;
  let availableCurrencies = availableCurrenciesParam;

  const lineItems = lineItemsParam;
  lineItems.forEach((x, ind) => {
    if (ind !== i) {
      return;
    }

    curChangeFnc(x, newCur);
  });

  if (!!oldCur && oldCur !== primaryCurrency) {
    const othersUseOldCurrency = cur === oldCur || lineItems.some((x, ind) => x.cur === oldCur || x.agtCur === oldCur);

    if (!othersUseOldCurrency) {
      availableCurrencies = availableCurrencies.filter(x => x !== oldCur);
      if (cur1 === oldCur) {
        cur1 = cur2;
        exRate1 = exRate2;
        cur2 = null;
        exRate2 = 0;
      }
      if (cur2 === oldCur) {
        cur2 = null;
        exRate2 = 0;
      }
    }
  }

  if (!!newCur && newCur !== primaryCurrency) {
    if (!availableCurrencies.some(x => x === newCur)) {
      availableCurrencies.push(newCur);
    }

    if (cur1 !== newCur && cur2 !== newCur) {
      if (_.isEmpty(cur1)) {
        cur1 = newCur;
        exRate1 = 0;
      } else {
        cur2 = newCur;
        exRate2 = 0;
      }
    }
  }

  return { invCur1: cur1 ?? '', invCur2: cur2 ?? '', exRate1: exRate1??0, exRate2: exRate2??0, availableCurrencies, lineItems };
}

/**
 * Utility function to process Bill or Invoice line item currency change. It keeps track of all currencies in line items to make sure max 3 currencies are used
 * After analyzing all line items it returns which are the currencies in use, which is currency 1 and 2 and matching exchange rate
 * In case currency 1 is removed (not used any more) it moves currency 2 to currency 1
 *
 * @export
 * @param {(string|null|undefined)} cur
 * @param {(string|null|undefined)} newCur
 * @param {(string|null|undefined)} oldCur
 * @param {number} i
 * @param {Array<string>} availableCurrencies
 * @param {(string|null|undefined)} cur1Param
 * @param {(string|null|undefined)} cur2Param
 * @param {(number|null|undefined)} exRate1Param
 * @param {(number|null|undefined)} exRate2Param
 * @param {(string|null|undefined)} primaryCurrency
 * @param {Array<BillInvoiceLineItem>} lineItems
 * @return {*} 
 */
export function handleBillOrInvoiceLineItemCurrencyChange(
  cur:string,
  newCur:string|null|undefined,
  oldCur:string|null|undefined,
  i:number,
  availableCurrencies:Array<string>,
  cur1Param:string|null|undefined,
  cur2Param:string|null|undefined,
  exRate1Param:number|null|undefined,
  exRate2Param:number|null|undefined,
  primaryCurrency:string|null|undefined,
  lineItems:Array<BillInvoiceLineItem>
) {
  return billOrInvoiceCurrencyChangeWorker(cur, newCur, oldCur, i, availableCurrencies, cur1Param, cur2Param, exRate1Param, exRate2Param, primaryCurrency, lineItems, applyLineItemCurrencyChange);
}

/**
  * Utility function to process Bill or Invoice line item Agent currency change. It keeps track of all currencies in line items to make sure max 3 currencies are used
 * After analyzing all line items it returns which are the currencies in use, which is currency 1 and 2 and matching exchange rate
 * In case currency 1 is removed (not used any more) it moves currency 2 to currency 1
 *
 * @export
 * @param {(string|null|undefined)} cur
 * @param {(string|null|undefined)} newCur
 * @param {(string|null|undefined)} oldCur
 * @param {number} i
 * @param {Array<string>} availableCurrencies
 * @param {(string|null|undefined)} cur1Param
 * @param {(string|null|undefined)} cur2Param
 * @param {(number|null|undefined)} exRate1Param
 * @param {(number|null|undefined)} exRate2Param
 * @param {(string|null|undefined)} primaryCurrency
 * @param {Array<BillInvoiceLineItem>} lineItems
 * @return {*} 
 */
export function handleBillOrInvoiceLineItemAgentCurrencyChange(
  cur:string|null|undefined,
  newCur:string|null|undefined,
  oldCur:string|null|undefined,
  i:number,
  availableCurrencies:Array<string>,
  cur1Param:string|null|undefined,
  cur2Param:string|null|undefined,
  exRate1Param:number|null|undefined,
  exRate2Param:number|null|undefined,
  primaryCurrency:string|null|undefined,
  lineItems:Array<BillInvoiceLineItem>
) {
  return billOrInvoiceCurrencyChangeWorker(cur, newCur, oldCur, i, availableCurrencies, cur1Param, cur2Param, exRate1Param, exRate2Param, primaryCurrency, lineItems, applyLineItemAgentCurrencyChange);
}

/**
 * Utility function for Bills and Invoices. Calculates amount in header currency
 *
 * @export
 * @param {(number|null|undefined)} rate
 * @param {(number|null|undefined)} qty
 * @param {(string|null|undefined)} cur
 * @param {(string|null|undefined)} headerCurrency
 * @param {(string|null|undefined)} primaryCurrency
 * @param {(string|null|undefined)} cur1
 * @param {(string|null|undefined)} cur2
 * @param {(string|null|undefined)} cur3
 * @param {(string|null|undefined)} cur4
 * @param {(number|null|undefined)} exRate1
 * @param {(number|null|undefined)} exRate2
 * @param {(number|null|undefined)} exRate3
 * @param {(number|null|undefined)} exRate4
 * @return {*} 
 */
export function calculateHeaderCurrencyAmount(
  rate:number|null|undefined,
  qty:number|null|undefined,
  cur:string|null|undefined,
  headerCurrency:string|null|undefined,
  primaryCurrency:string|null|undefined,
  cur1:string|null|undefined,
  cur2:string|null|undefined,
  cur3:string|null|undefined,
  cur4:string|null|undefined,
  exRate1:number|null|undefined,
  exRate2:number|null|undefined,
  exRate3:number|null|undefined,
  exRate4:number|null|undefined,
) {
  let amount = null;
  if (!qty || !rate || !cur) {
    return amount;
  }

  if (cur === headerCurrency) {
    amount = qty * rate;
  } else {
    if (headerCurrency === primaryCurrency) {
      if (cur === cur1 && !!exRate1) {
        amount = qty * rate * exRate1;
      }
      if (cur === cur2 && !!exRate2) {
        amount = qty * rate * exRate2;
      }
      if (cur === cur3 && !!exRate3) {
        amount = qty * rate * exRate3;
      }
      if (cur === cur4 && !!exRate4) {
        amount = qty * rate * exRate4;
      }
    } else {
      // const headerToPrimaryRate = headerCurrency === cur1 ? exRate1 : exRate2;
      let headerToPrimaryRate = 1;
      if (headerCurrency === cur1) headerToPrimaryRate = exRate1??0;
      if (headerCurrency === cur2) headerToPrimaryRate = exRate2??0;
      if (headerCurrency === cur3) headerToPrimaryRate = exRate3??0;
      if (headerCurrency === cur4) headerToPrimaryRate = exRate4??0;

      if (headerToPrimaryRate !== 0) {
        const amountInPrimary = calculatePrimaryCurrencyAmount(rate, qty, cur, primaryCurrency, cur1, cur2, exRate1, exRate2);
        if (amountInPrimary) {
          amount = amountInPrimary / headerToPrimaryRate;
        }
      }
    }
  }

  return amount;
}

/**
 *Utility function for Bills and Invoices. Calculates amount in primary currency
 *
 * @export
 * @param {(number|null|undefined)} rate
 * @param {(number|null|undefined)} qty
 * @param {(string|null|undefined)} cur
 * @param {(string|null|undefined)} primaryCurrency
 * @param {(string|null|undefined)} cur1
 * @param {(string|null|undefined)} cur2
 * @param {(number|null|undefined)} exRate1
 * @param {(number|null|undefined)} exRate2
 * @return {*} 
 */
export function calculatePrimaryCurrencyAmount(
  rate:number|null|undefined,
  qty:number|null|undefined,
  cur:string|null|undefined,
  primaryCurrency:string|null|undefined,
  cur1:string|null|undefined,
  cur2:string|null|undefined,
  exRate1:number|null|undefined,
  exRate2:number|null|undefined
) {
  let amount = null;

  if (!!qty && !!rate && !!cur) {
    if (cur === primaryCurrency) {
      return qty * rate;
    }
    if (cur === cur1 && !!exRate1) {
      amount = qty * rate * exRate1;
    }
    if (cur === cur2 && !!exRate2) {
      amount = qty * rate * exRate2;
    }
  }

  return amount;
}


/**
 * Utility function to calculate amount for currency in primary currency. It is used for calculation for Bills and Invoices
 *
 * @export
 * @param {(number|null|undefined)} amountParam
 * @param {(string|null|undefined)} cur
 * @param {(string|null|undefined)} primaryCurrency
 * @param {(string|null|undefined)} cur1
 * @param {(string|null|undefined)} cur2
 * @param {(string|null|undefined)} cur3
 * @param {(string|null|undefined)} cur4
 * @param {(number|null|undefined)} exRate1
 * @param {(number|null|undefined)} exRate2
 * @param {(number|null|undefined)} exRate3
 * @param {(number|null|undefined)} exRate4
 * @return {*} 
 */
export function calculatePrimaryCurrencyAmountFor(
  amountParam:number|null|undefined,
  cur:string|null|undefined,
  primaryCurrency:string|null|undefined,
  cur1:string|null|undefined,
  cur2:string|null|undefined,
  cur3:string|null|undefined,
  cur4:string|null|undefined,
  exRate1:number|null|undefined,
  exRate2:number|null|undefined,
  exRate3:number|null|undefined,
  exRate4:number|null|undefined,
): number {
  let amount = null;

  if (!!amountParam && !!cur) {
    if (cur === primaryCurrency) {
      return amountParam;
    }
    if (cur === cur1 && !!exRate1) {
      amount = amountParam * exRate1;
    }
    if (cur === cur2 && !!exRate2) {
      amount = amountParam * exRate2;
    }
    if (cur === cur1 && !!exRate3) {
      amount = amountParam * exRate3;
    }
    if (cur === cur2 && !!exRate4) {
      amount = amountParam * exRate4;
    }
  }

  return amount ?? 0;
}

/**
 * Utility function to calculate CrDb item amount based on its type and if it is direct shipment or not
 *
 * @export
 * @param {number} value
 * @param {(number|null)} type
 * @param {number} ps
 * @param {boolean} direct
 * @return {*} 
 */
export function calculateCrDbValues(value:number, type:number, ps:number|null, direct:boolean) {
  let amount = 0;
  let profitShare = 0;
  if (direct === undefined) {
    const err = new Error();
    window.console.log(err.stack);
    window.console.log(type, value, ps, direct);
    window.console.log('------------');
  }

  if (!direct) {
    switch (type) {
      case 5: 
        profitShare = ps ? ps * value / -100.0 : 0;
        amount = value + profitShare;
        return { amount, profitShare };
      case 15:
        profitShare = ps ? ps * value / 100.0 : 0;
        amount = -value + profitShare;
        return { amount, profitShare };
      case 27:
        profitShare = ps ? ps * value / 100.0 : 0;
        return { amount: profitShare, profitShare };
      case 37:
        profitShare = ps ? ps * value / -100.0 : 0;
        return { amount: profitShare, profitShare };
      case 7:
        profitShare = ps ? ps * value / 100.0 : 0;
        return { amount: profitShare, profitShare };
      case 17:
        profitShare = ps ? ps * value / -100.0 : 0;
        return { amount: profitShare, profitShare };
      case 8:
      case 18:
        profitShare = ps ? ps * value / 100.0 : 0;
        amount = value + profitShare;
        return { amount, profitShare };
      case 13:
      case 14:
        profitShare = ps ? ps * value / -100.0 : 0;
        amount = value + profitShare;
        return { amount, profitShare };
      case 12:
        profitShare = ps ? ps * value / -100.0 : 0;
        amount = value + profitShare;
        return { amount, profitShare };
      case 3:
      case 4:
        profitShare = ps ? ps * value / 100.0 : 0;
        amount = -value + profitShare;
        return { amount, profitShare };
      case 2:
        profitShare = ps ? ps * value / 100.0 : 0;
        amount = -value + profitShare;
        return { amount, profitShare };
      case 11:
        profitShare = ps ? ps * value / -100.0 : 0;
        return { amount: profitShare, profitShare };
      case 1:
        profitShare = ps ? ps * value / 100.0 : 0;
        return { amount: profitShare, profitShare };
      default:
        // window.console.log('Returning default');
        // window.console.log(type, value, ps, direct);
        return { amount: 0, profitShare: 0 };
    }
  } else {
    switch (type) {
      case 5: 
        profitShare = ps ? ps * value / -100.0 : 0;
        amount = value + profitShare;
        return { amount, profitShare };
      case 15:
        profitShare = ps ? ps * value / 100.0 : 0;
        amount = -value + profitShare;
        return { amount, profitShare };
      case 27:
        profitShare = ps ? ps * value / -100.0 : 0;
        return { amount: profitShare, profitShare };
      case 37:
        profitShare = ps ? ps * value / 100.0 : 0;
        return { amount: profitShare, profitShare };
      case 7:
        profitShare = ps ? ps * value / -100.0 : 0;
        return { amount: profitShare, profitShare };
      case 17:
        profitShare = ps ? ps * value / 100.0 : 0;
        return { amount: profitShare, profitShare };
      case 8:
      case 18:
        profitShare = ps ? ps * value / -100.0 : 0;
        amount = value + profitShare;
        return { amount, profitShare };
      case 11:
        profitShare = ps ? ps * value / 100.0 : 0;
        return { amount: profitShare, profitShare };
      case 1:
        profitShare = ps ? ps * value / -100.0 : 0;
        return { amount: profitShare, profitShare };
      case 13:
      case 14:
        profitShare = ps ? ps * value / 100.0 : 0;
        amount = value + profitShare;
        return { amount, profitShare };
      case 3:
      case 4:
        profitShare = ps ? ps * value / -100.0 : 0;
        amount = -value + profitShare;
        return { amount, profitShare };
      case 12:
        profitShare = ps ? ps * value / 100.0 : 0;
        amount = value + profitShare;
        return { amount, profitShare };
      case 2:
        profitShare = ps ? ps * value / -100.0 : 0;
        amount = -value + profitShare;
        return { amount, profitShare };
      default:
        // window.console.log('Returning default');
        // window.console.log(type, value, ps, direct);
        return { amount: 0, profitShare: 0 };
    }
  }
}

/**
 * Get number of decimal places for currency. It checks currency in globally available list of currencies which are initialized during login
 *
 * @export
 * @param {string} currency
 * @return {*} 
 */
export function getDecimal(currency:string) {
  const currencies = getCurrencies();
  if (!!currencies && currencies.length > 0) {
    const c = currencies.find(x => x.currency === currency);
    return !!c ? c.decimal : 0;
  }

  return 0;
}

/**
 * Utility function to calculate amount in currency. It checks currency decimal places property and formats (rounds) number accordingly
 *
 * @export
 * @param {(number|null|undefined)} a
 * @param {(string|null|undefined)} c
 * @return {*} 
 */
export function getValueInCurrency(a:number|null|undefined, c:string|null|undefined): number {
  if (!c || a === null || a === undefined) {
    return 0;
  }

  const decimal = getDecimal(c);

  return parseFloat(a.toFixed(decimal));
}

export function getNumberStringInCurrency(a:number|null|undefined, c:string|null|undefined): string {
  if (!c || a === null || a === undefined) {
    return '';
  }

  const decimal = getDecimal(c);

  return a.toFixed(decimal);
}


/**
 * Make trackable listitem(or detaillist) in copy mode on load
 *
 * @export
 * @param {any[]} copyApiResult
 * @param {any} resultList
 * @param {any} elementType
 */
export function makeTrackableListItemInCopyMode(copyApiResult: any[], resultList: any, elementType: any) {
  let propertyValue = Object.create(null);
  copyApiResult.forEach(x => {
    let newElement = new elementType();
    newElement.trackable = true;
    const elementProp = Object.getOwnPropertyNames(newElement)
    const trackaProp = elementProp.filter(name => !Object.getOwnPropertyDescriptor(newElement, 'noTrackProps')?.value.includes(name))
    trackaProp.forEach((y) => {
      propertyValue = Object.getOwnPropertyDescriptor(x, y)?.value
      Object.defineProperty(newElement, y, { value: propertyValue })
    })
    resultList.push(newElement);
  });
}

/**
 * Check if object or string is null or empty or whitespace
 *
 * @export
 * @param {string} str
 * @param {boolean} isWhiteSpaceCheck
 * @return {boolean} 
 */
export function isNullOrEmpty(str : string | null, isWhiteSpaceCheck = true) : boolean {

  if(!str)
    return true;

  if(isWhiteSpaceCheck)
   // return !str.trim();
    return typeof str === 'string' ? !str.trim() : false;
  else 
    return false;
}

/**
 * Tries to set caret (cursor) of given HTML input element to given position
 *
 * @export
 * @param {HTMLInputElement} el
 * @param {number} caretPos
 * @return {*} 
 */
export function setCaretPosition(el:HTMLInputElement, caretPos:number) {
  // this is used to not only get "focus", but
  // to make sure we don't have it everything -selected-
  // (it causes an issue in chrome, and having it doesn't hurt any other browser)
  // eslint-disable-next-line no-self-assign
  el.value = el.value;

  if (el !== null) {
    const elAsAny = el as any;
    if (elAsAny.createTextRange) {
      const range = elAsAny.createTextRange();
      range.move('character', caretPos);
      range.select();
      return true;
    }
    // (el.selectionStart === 0 added for Firefox bug)
    if (el.selectionStart || el.selectionStart === 0) {
      el.focus();
      el.setSelectionRange(caretPos, caretPos);
      return true;
    }

    el.focus();
    return false;
  }
}

/**
 * Utility function to create Bill/Invoice parent url based on given context
 *
 * @export
 * @param {string} context
 * @param {number} contextId
 * @return {*} 
 */
export function createBillInvoiceCrdbParentUrlFromContext(context:string, contextId:number) {
  if (!context || !contextId) {
    return null;
  }

  if (context === 'oiviewmbl') {
    return `/oceanImport/mbl/view/${contextId}`;
  }
  if (context === 'oieditmbl') {
    return `/oceanImport/mbl/edit/${contextId}`;
  }
  if (context === 'oiviewhbl') {
    return `/oceanImport/hbl/view/${contextId}`;
  }
  if (context === 'oiedithbl') {
    return `/oceanImport/hbl/edit/${contextId}`;
  }

  return null;
}

/**
 * Checks whether array's last element is empty. Used for tables to not allow new line item to show if the last one is empty.
 * It is possible to define additional values that are treated as empty ones (for examnple: 'N/A') and properties in array to skip for checking
 *
 * @export
 * @param {*} arr
 * @param {(Array<any>|null)} additionalEmptyValues
 * @param {(Array<string>|null)} propertiesToSkip
 * @return {*} 
 */
export function isLastLineItemEmpty(arr:any, additionalEmptyValues:Array<any>|null = null, propertiesToSkip:Array<string>|null = null) {
  return Array.isArray(arr) && arr.length > 0 &&  isEveryPropertyEmpty(arr[arr.length - 1], additionalEmptyValues, propertiesToSkip);
}

// [230410] improve function
// export function isEveryPropertyEmpty(obj:any, additionalEmptyValues:Array<any>|null = null, propertiesToSkip:Array<string>|null = null) {
//   type CheckFunctor = (x:any) => boolean;

//   const isNullOrEmpty = (str: string) => str === null || str.match(/^ *$/) !== null;

//   const additionalChecks = additionalEmptyValues ?? [];

//   const emptyCheck:CheckFunctor = x => {
//     if (_.isString(x)) {
//       return isNullOrEmpty(x) || additionalChecks.some(a => a === x);
//     }

//     if (_.isNumber(x)) {
//       return !x || x === 0 || additionalChecks.some(a => a === x);
//     }

//     return !x || additionalChecks.some(a => a === x);
//   };

//   return !!propertiesToSkip && Array.isArray(propertiesToSkip) && propertiesToSkip.length > 0
//     ? !obj || _.values(_.omit(obj, propertiesToSkip)).every(emptyCheck)
//     : !obj || _.values(obj).every(emptyCheck);
// }


/**
 * Checks whether object is empty. Used for tables to not allow new line item to show if the last one is empty.
 * It is possible to define additional values that are treated as empty ones (for examnple: 'poNo':'N/A') and properties in array to skip for checking
 *
 * @export
 * @param {*} obj
 * @param {(any|null)} additionalEmptyValues
 * @param {(Array<string>|null)} propertiesToSkip
 * @return {*} 
 */
export function isEveryPropertyEmpty(obj: any, additionalEmptyValues: any | null = null, propertiesToSkip: Array<string> | null = null) {
  if(!obj) return true;
  type CheckFunctor = (x:any) => boolean;
  let testObj = _.cloneDeep(obj);
  let specialObj: any = [];
  if(!!propertiesToSkip && Array.isArray(propertiesToSkip) && propertiesToSkip.length > 0)
    testObj = _.omit(obj, propertiesToSkip)

  if (!!additionalEmptyValues) {
    specialObj = additionalEmptyValues;
    const keys = Object.keys(additionalEmptyValues)
    for (let i = 0; i < keys.length; i++) {
      const keyName = keys[i];
      delete testObj[keyName]
    }
  }

  const emptyCheck:CheckFunctor = x => {
    if (_.isString(x)) {
      return isNullOrEmpty(x);
    }

    else if (_.isNumber(x)) {
      return !x || x === 0;
    }

    return !x ;
  };

  const emptyCheckSpecial: CheckFunctor = x => {
    if (_.isString(x)) {
      return isNullOrEmpty(x) || specialObj[x] === obj[x];
    }

    else if (_.isNumber(x)) {
      return !x || x === 0 || specialObj[x] === obj[x];
    }

    return !x || specialObj[x] === obj[x];
  };

  return _.values(testObj).every(emptyCheck) && _.keys(specialObj).every(emptyCheckSpecial);
}

export function isEveryPropertyEmptyNew(obj: any, additionalEmptyValues: any | null = null, propertiesToSkip: Array<string> | null = null) {
  if(!obj) return { isEmpty: true, nonEmptyProperties: {} };
  
  type CheckFunctor = (x: any, key: string) => boolean;
  let testObj = _.cloneDeep(obj);
  let specialObj: any = [];
  let nonEmptyProperties: { [key: string]: any } = {};

  // propertiesToSkip 처리 전에 원본 객체 출력
  console.log('검사 전 전체 속성:', Object.entries(testObj)
    .filter(([_, value]) => value !== undefined && value !== null)
    .map(([key, value]) => `${key}: ${value}`));

  if(!!propertiesToSkip && Array.isArray(propertiesToSkip) && propertiesToSkip.length > 0) {
    console.log('건너뛸 속성들:', propertiesToSkip);
    testObj = _.omit(obj, propertiesToSkip);
  }

  // propertiesToSkip 처리 후 남은 속성들 출력
  console.log('검사할 속성들:', Object.entries(testObj)
    .filter(([_, value]) => value !== undefined && value !== null)
    .map(([key, value]) => `${key}: ${value}`));

  if (!!additionalEmptyValues) {
    specialObj = additionalEmptyValues;
    const keys = Object.keys(additionalEmptyValues)
    for (let i = 0; i < keys.length; i++) {
      const keyName = keys[i];
      delete testObj[keyName]
    }
  }

  const emptyCheck: CheckFunctor = (x, key) => {
    let isEmpty = true;
    if (_.isString(x)) {
      isEmpty = isNullOrEmpty(x);
    }
    else if (_.isNumber(x)) {
      isEmpty = !x || x === 0;
    }
    else {
      isEmpty = !x;
    }

    if (!isEmpty) {
      nonEmptyProperties[key] = x;
      console.log(`비어있지 않은 속성 발견 -> ${key}: ${x}`);
    }
    return isEmpty;
  };

  const emptyCheckSpecial: CheckFunctor = (x, key) => {
    let isEmpty = true;
    if (_.isString(x)) {
      isEmpty = isNullOrEmpty(x) || specialObj[x] === obj[x];
    }
    else if (_.isNumber(x)) {
      isEmpty = !x || x === 0 || specialObj[x] === obj[x];
    }
    else {
      isEmpty = !x || specialObj[x] === obj[x];
    }

    if (!isEmpty) {
      nonEmptyProperties[key] = x;
      console.log(`특별 검사에서 비어있지 않은 속성 발견 -> ${key}: ${x}`);
    }
    return isEmpty;
  };

  const isAllEmpty = _.every(
    Object.entries(testObj),
    ([key, value]) => emptyCheck(value, key)
  ) && _.every(
    Object.entries(specialObj),
    ([key]) => emptyCheckSpecial(obj[key], key)
  );

  return {
    isEmpty: isAllEmpty,
    nonEmptyProperties: nonEmptyProperties
  };
}

/**
 * Utility function to format amount as string to given number of decimal places
 *
 * @export
 * @param {*} amount
 * @param {number} [decimalCount=2]
 * @param {string} [decimals='.']
 * @param {string} [thousands=',']
 * @return {*} 
 */
export function formatAmount(amount:any, decimalCount = 2, decimal = '.', thousands = ',') {
  try {
    decimalCount = Math.abs(decimalCount);
    decimalCount = isNaN(decimalCount) ? 2 : decimalCount;

    const negativeSign = amount < 0 ? "-" : "";

    let i:any = parseInt(amount = Math.abs(Number(amount) || 0).toFixed(decimalCount)).toString();
    let j = (i.length > 3) ? i.length % 3 : 0;

    return negativeSign + (j ? i.substr(0, j) + thousands : '') + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + thousands) + (decimalCount ? decimal + Math.abs(amount - i).toFixed(decimalCount).slice(2) : "");
  } catch (e) {
    console.log(e);
    return '';
  }
}

export function isElementFocusable(el:HTMLElement|null):boolean {
  if (!el) {
    return false;
  }

  const elAsAny = el as any;
  return !elAsAny.disabled && !!elAsAny.focus;
}

/**
 *Extract query parameters as key-value pair from history
 *
 * @export
 * @param {History} history
 */
export function getQueryParamObject(history:History) {
  const urlSearchParams = new URLSearchParams(history?.location?.search);
  return Object.fromEntries(urlSearchParams.entries());
}

export function parseJwt(token: string) {
  const base64Url = token.split('.')[1];
  const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
  const jsonPayload = decodeURIComponent(atob(base64).split('').map(function(c) {
    return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
  }).join(''));

  return JSON.parse(jsonPayload);
}

//<pt211201>
export function appendLine(str1:string, str2:string): string {
  let result = str1;
  if (str1) result += '\r\n';
  return result + str2;
}

/**
 *Convert number in inches to cm
 *
 * @export
 * @param {number} num
 */
export function cbmInchToCm(num: number) {
  if (num === null || num === undefined || isNaN(num)) {
    return 0;
  }

  return Math.round(num / 16387.0486 * 100) / 100;
}

/**
 *Convert number in cm to inches
 *
 * @export
 * @param {number} num
 */
export function cbmCmToInch(num: number) {
  if (num === null || num === undefined || isNaN(num)) {
    return 0;
  }
  return Math.round((num * 16387.0486) * 100) / 100;
}


/**
 *Convert number in inches to cm
 *
 * @export
 * @param {number} num
 */
export function lbsInchToCm(num: number) {
  if (num === null || num === undefined || isNaN(num)) {
    return 0;
  }

  return Math.round(num * 1.639507 * 100) / 100;
}

/**
 *Convert number in cm to inches
 *
 * @export
 * @param {number} num
 */
export function lbsCmToInch(num: number) {
  if (num === null || num === undefined || isNaN(num)) {
    return 0;
  }

  return Math.round((num / 1.639507) * 100) / 100;
}


/**
 * Utility function to construct (for example) Shipper details when selecting company lookup
 *
 * @export
 * @param {CompanyPreview} c
 * @return {*}  {string}
 */
export function constructCompanyDetails(c: CompanyPreview|null|undefined): string {
  let details = c?.shortName || '';
  if (c?.address) {
    details = `${details}\n${c?.address}`;
  }
  const locationParts = [];
  if (c?.city) { locationParts.push(c?.city); }
  if (c?.state) { locationParts.push(c?.state); }
  if (c?.zip) { locationParts.push(c?.zip); }

  if (locationParts.length > 0) {
    details = `${details}\n${locationParts.join(', ')}`;
  }
  if (c?.fax || c?.tel) {
    const telFaxParts = [];
    if (c?.tel) {
      telFaxParts.push(c?.tel);
    }
    if (c?.fax) {
      telFaxParts.push(c?.fax);
    }
    if (telFaxParts.length > 0) {
      details = `${details}\n${telFaxParts.join(', ')}`;
    }
  }

  return details;
}

/**
 * Sleep async function
 * @param ms 
 * @returns 
 */
export function sleep(ms:number): Promise<void> {
  return new Promise(resolve => setTimeout(resolve, ms));
}


/**
 * 
 * @param str 
 * @param index 
 * @param length 
 * @param replace 
 */
export function replaceAt(str:string, index:number, length:number, replace: string){
  if(!str)
  return str
  else return str.substring(0, index) + replace + str.substring(index + 1, str.length);
}

/**
 * pt220912: return first line only
 * @param str multiline string
 * @returns 
 */
export function stringGetFirstLine(str:string) {
  if(!str || str.length === 0) return str;
  else {
    const arr  = str.match(/^.*$/m)??[];
    if(arr.length > 0)
      return arr[0];
    else 
      return '';
  }
}

export function stringGetSecondLines(str:string) {
  if(!str || str.length === 0) return str;
  const index = str.indexOf('\n');
  if(index !== -1) {
    return str.substring(index + 1);
  } else {
    return '';
  }
}

export function cbmToCft(cbm: number, retDecimal:number = -1) {
  if(cbm < 0) return 0;
  if(retDecimal > -1) {
    return mathRound(cbm * 35.3147, retDecimal);
  } else {
    return cbm * 35.3147;
  }
}

export function left(str: string, n: number) {
  if(!str || str.length <= 0) return '';
  else if (n < str.length) return str.substring(0, n);
  else return str;
}

function filterListBySecTask(filterList: IfmsConfigMenuItem[], secTask: string) : IfmsConfigMenuItem[]
{
  return filterList = filterList.filter(x => {
    if (x.fmsSecTask !== secTask)
    {
      x.items = x.items?.filter(f => f.fmsSecTask !== secTask);
      return x;
    }
    else
      return null;
  });
}

export function MenuFilterGrents(filterList: IfmsConfigMenuItem[], grents: SecurityGrant[] | null | undefined, appContext: any): IfmsConfigMenuItem[] {
  // setup
  let disableMenu: IfmsConfigMenuItem | undefined;

  // <250131.jhlee - AMS와 ISF의 Enable 항목의 체크 여부와 관계없이 메뉴가 보이도록 수정>
  //AMS Setup
  if (!appContext.suntekSettings?.compliance?.amsEnableAll) {
    if (!appContext.suntekSettings?.compliance?.amsEnable) {
      // filterList = filterList.filter(x => !x.text?.toString() || !x.text.toString().includes('AMS'));
      filterList = filterList.filter(x => !x.text?.toString() || !x.text.toString().includes('ACI'));
    }
    else {
      if (appContext.suntekSettings?.compliance?.amsEnable) {
        if (_.isEmpty(appContext.suntekSettings.compliance.amsId1) && _.isEmpty(appContext.suntekSettings.compliance.amsId2) && _.isEmpty(appContext.suntekSettings.compliance.amsId3)) {
          disableMenu = filterList.find(x => x.text?.toString().includes('ACI eManifest'));
          if (disableMenu) disableMenu.disable = true;
          // disableMenu = filterList.find(x => x.text?.toString().includes('AMS'));
          // if (disableMenu) disableMenu.disable = true;
        }
      }
    }
  }

  //ACI Setup
  if (!appContext.suntekSettings?.compliance?.amsUseeManifest) {
    filterList = filterList.filter(x => !x.text?.toString() || !x.text.toString().includes('ACI eManifest'));
  }

  //ISF Setup
  // if (!appContext.suntekSettings?.compliance?.isfEnableAll) {
  //   if (!appContext.suntekSettings?.compliance?.isfEnable) {
  //     filterList = filterList.filter(x => !x.text?.toString() || !x.text.toString().includes('ISF'));
  //   }
  //   else {
  //     if (_.isEmpty(appContext.suntekSettings.compliance.isfId1) && _.isEmpty(appContext.suntekSettings.compliance.isfId2) && _.isEmpty(appContext.suntekSettings.compliance.isfId3)) {
  //       disableMenu = filterList.find(x => x.text?.toString().includes('ISF'));
  //       if (disableMenu) disableMenu.disable = true;
  //     }
  //   }
  // }

  if (!appContext.suntekSettings?.accounting?.useSalesTaxReturn)
  {
    filterList = filterListBySecTask(filterList, FmsSecTask.AcctSalesTaxReturnList);
  }
  if (!appContext.suntekSettings?.company?.enableBranch) {
    filterList = filterListBySecTask(filterList, FmsSecTask.OPRptBranchPerform);
  }
  //<240529.dwshin - SiS만 가능하던것 사용할 수 있게 수정 됨. 2024-01-12>
  //// if(appContext.user?.id !== getFmsGlobal().SUNTEK_ID){
  // if(!appContext.user?.isSuntekAdmin) {
  //   filterList = filterListBySecTask(filterList, FmsSecTask.AcctBadDebtExpense);
  // }

  // security
  if(grents === null || grents === undefined) return filterList;

  return filterList.filter(job => {
    if (!job.fmsSecTask
      || grents?.find(g => g.securityTaskCode === job.fmsSecTask) === undefined
      || grents?.find(g => g.securityTaskCode === job.fmsSecTask && g.grantRead === true)) {
      // sub job (level 1 filter)
      job.items = job.items?.filter(sjob => !sjob.fmsSecTask
        || grents?.find(g => g.securityTaskCode === sjob.fmsSecTask) === undefined
        || grents?.find(g => g.securityTaskCode === sjob.fmsSecTask && g.grantRead === true));

      // level 0 컴포넌트에 action이 있거나,
      // 하위 아이템이 있는 경우에만 메뉴 보여주도록 함.
      //if(job.link || job.popupComponent || job.metadata || (job.items && job.items.length > 0))
      //2305233 위 기능 주석처리
      if (job.nonItemThenHide && (job.items?.length ?? 0) <= 0)
        return null;
      else
        return job;
    }
    //240919 - mskang > Deposit / Undo Deposit은 Grant가 Deposit/UndoDeposit일때 뿐 아니라 Check Clear/Undo Check Clear일때도 활성화 되어야함. 
    //Deposit/UndoDeposit Grant가 false여도 Check Clear/Undo Check Clear Grant가 true면 메뉴에 나타나야 한다.
    else if ((job.fmsSecTask === FmsSecTask.AcctDeposit || job.fmsSecTask === FmsSecTask.AcctDepositClear) &&
      (grents?.find(g => g.securityTaskCode === FmsSecTask.AcctDeposit) && grents?.find(g => g.securityTaskCode === FmsSecTask.AcctDepositClear && g.grantRead === true))) {
      return job;
    }
    else if ((job.fmsSecTask === FmsSecTask.AcctUndoDeposit || job.fmsSecTask === FmsSecTask.AcctUndoDepositClear) &&
      (grents?.find(g => g.securityTaskCode === FmsSecTask.AcctUndoDeposit) && grents?.find(g => g.securityTaskCode === FmsSecTask.AcctUndoDepositClear && g.grantRead === true))) {
      return job;
    }
    else if ((job.fmsSecTask === FmsSecTask.AcctAgingAR ) &&
      (grents?.find(g => (g.securityTaskCode === FmsSecTask.AcctAgingAR || g.securityTaskCode === FmsSecTask.AcctAgingAP || g.securityTaskCode === FmsSecTask.AcctAgingAgent || g.securityTaskCode === FmsSecTask.AcctAgingARAP || g.securityTaskCode === FmsSecTask.AcctAgingOther) && g.grantRead === true))) {
      return job;
    }
    else
      return null;
  });
}



 const storageDetailKey = new Map<string, string>([
    [JobNames.Invoice, "/accounting/invoice"],
    [JobNames.Bill, "/accounting/bill"],
    [JobNames.CrDb, "/accounting/crdb"],
    [JobNames.GInvo, "/accounting/acGeneralInvoice"],
    [JobNames.GBill, "/accounting/acGeneralBill"],
  ]);



export function MenuFilterForBillings(filterList: IfmsConfigMenuItem[], currentListJobName: JobNames, currentUrl: string): IfmsConfigMenuItem[] {
  let jobName = currentListJobName;
  //console.log(`menus.job -1 `, `currentListJobName`, currentListJobName);

  switch (jobName) {
    case JobNames.OpInvoice:
      jobName = JobNames.Invoice;
      break;
    case JobNames.OpBill:
      jobName = JobNames.Bill;
      break;
    case JobNames.OpCrDb:
      jobName = JobNames.CrDb;
      break;
  }

  if (!jobName) {
    // find detail url.
    storageDetailKey.forEach((value, key) => {
      //console.log(`menus.job -2 `, `key, value`, key, value);
      if (currentUrl.startsWith(value)){
        jobName = key as JobNames;
      }
    })
  }

  //console.log(`menus.job -3 `, `currentListJobName`, currentListJobName, `jobName`, jobName, filterList);
  filterList = filterList.filter(job => job.level == 0 || (job.moreMenuJobName && job.moreMenuJobName === jobName));
  //console.log(`menus.job -4 `, filterList);

  return filterList;
}

export function getJobNamesByCurrentUrl(map : any, searchValue : any) {
  for (let [key, value] of map.entries()) {
    if (value === searchValue)
      return key as JobNames;
  }
  return JobNames.None;
}

export function getListItemByJobName(jobName: JobNames) {
  switch (jobName) {
    case JobNames.OIMbl:
      return OiMblListItem;
    case JobNames.OIHbl:
      return OiHblListItem;
    case JobNames.AIMbl:
      return AiMblListItem;
    case JobNames.AIHbl:
      return AiHblListItem;
    case JobNames.OEMbl:
      return OeMblListItem;
    case JobNames.OEHbl:
      return OeHblListItem;
    case JobNames.OEBook:
      return OeBookingListItem;
    case JobNames.AEMbl:
      return AeMblListItem;
    case JobNames.AEHbl:
      return AeHblListItem;
    case JobNames.OtherOP:
      return OtherOperationListItem;
    case JobNames.WHRcpt:
      return WhReciptsListItem;
    case JobNames.WHRcv:
      return WhRcvListItem;
    case JobNames.WHShip:
      return WhShipListItem;
    case JobNames.Company:
      return CodeCompanyListItem;
    case JobNames.BillPayment:
      return BillPaymentListItem;
    case JobNames.OIMPims:
    case JobNames.OEMPims:
    case JobNames.AIMPims:
    case JobNames.AEMPims:
      return PimsBookingListItem;
    case JobNames.OIHPims:
    case JobNames.OEHPims:
    case JobNames.AIHPims:
    case JobNames.AEHPims:
      return PimsVanningListItem;
    case JobNames.BatchRecog:
      return BatchRecogListItem;  
    case JobNames.Invoice:
    case JobNames.GInvo:
    case JobNames.OpInvoice:
      return InvoiceListItem;  
    case JobNames.Bill:
    case JobNames.GBill:
    case JobNames.OpBill:
      return BillListItem;
    case JobNames.CrDb:
    case JobNames.OpCrDb:
      return CrDbListItem;
    case JobNames.SlipJournal:
      return JournalLedgerListItem;
    case JobNames.BTOrder:
      return BTOrderListItem;
    case JobNames.BTLoadPlan:
      return BTLoadPlanListItem;
    case JobNames.BTDo:
      return BTLocalDOListItem;
    
    case JobNames.MyEvent:
      return MyEventListItem;  
      
    case JobNames.ISF:
      return IsfListItem;  

    case JobNames.AMSMaster:
      return AmsMasterListItem;  
    case JobNames.AMSVoyage:
      return AmsVoyageListItem;  
    case JobNames.AMSHouse:
      return AmsHouseListItem;  
    case JobNames.AMSUser:
      return AmsUserListItem;  
    case JobNames.AMSBranch:
      return AmsBranchListItem;  
    case JobNames.AMSHistory:
      return AmsHistoryListItem;  
    case JobNames.AMSBilling:
      return AmsBillingCodeListItem;  
    case JobNames.AMSC1History:
      return Ams1CHistoryListItem;  
      
    case JobNames.OrchidBaro:
      return OrchidBaroListItem;
    default:
      return undefined;

  }
}

export function GetCompanyNameNew(vID: number, vComName: string, vComType: string = 'C', vIgnoreBlank: boolean = false): string {
  let result = '';

  if (vID > 0) {
    if (!_.isEmpty(vComName))
      result = vComName.length > 0 ? vComName.substring(0, 50) : vComName;
    else
      result = '** Not Registered Entity **';
  }
  else {
    result = vIgnoreBlank ? '' : '** Blank Entity **';
  }
  return result;
}

export function getTooltipValue(value: string, jobName: JobNames, customLabel: string = '') {
  let result = ''

  if (_.isEmpty(value)) return result;

  if (!_.isEmpty(customLabel))
    result = `${customLabel} : ${value}`
  else {
    switch (jobName) {
      case JobNames.OIMbl:
      case JobNames.OEMbl:
        result = `MBL # : ${value}`
        break;
      case JobNames.AIMbl:
      case JobNames.AEMbl:
        result = `MAWB # : ${value}`
        break;
      case JobNames.OIHbl:
      case JobNames.OEHbl:
        result = `HBL # : ${value}`
        break;
      case JobNames.AIHbl:
      case JobNames.AEHbl:
        result = `HAWB # : ${value}`
        break;
      case JobNames.OEBook:
        result = `Booking # : ${value}`
        break;
      case JobNames.OtherOP:
        result = `Ref # : ${value}`
        break;
      case JobNames.WHRcpt:
        result = `Receipt # : ${value}`
        break;
      case JobNames.WHRcv:
        result = `Receiving ID : ${value}`
        break;
      case JobNames.WHShip:
        result = `Shipping ID : ${value}`
        break;
      case JobNames.Invoice:
      case JobNames.WHInvoice:
      case JobNames.WHStorageInv:
        result = `Invoice # : ${value}`
        break;
      case JobNames.GInvo:
        result = `G. Invoice # : ${value}`
        break;
      case JobNames.Bill:
      case JobNames.WHBill:
        result = `Bill # : ${value}`
        break;
      case JobNames.GBill:
        result = `G. Bill # : ${value}`
        break;
      case JobNames.CrDb:
      case JobNames.WHCrDb:
        result = `CrDb # : ${value}`
        break;
      case JobNames.SeaQuotation:
      case JobNames.AirQuotation:
      case JobNames.OtQuotation:
        result = `Quotation # : ${value}`
        break;
      case JobNames.OILoad:
        result = `Load Plan # : ${value}`
        break;
      case JobNames.OELoad:
        result = `Container # : ${value}`
        break;
      case JobNames.Company:
        result = `Company Name : ${value}`
        break;
      case JobNames.SalesTaxReturn:
        result = `Ref # : ${value}`
        break;
      case JobNames.PayrollSummary:
      case JobNames.Payroll2:
        result = `Ref # : ${value}`
        break;
      case JobNames.BTOrder:
        result = `PRO # : ${value}`
        break;
      case JobNames.BTLoadPlan:
        result = `Load # : ${value}`
        break;
      case JobNames.BTDo:
        result = `DO # : ${value}`
        break;
    }
  }
  return result;
}

export function findSecurityTask(appContext: IApplicationContext, taskCode: string) : SecurityGrant
{
  let result = appContext.securityGrants?.find(x => x.securityTaskCode === taskCode);
  return result ? result : new SecurityGrant({ grantRead: true, grantAdd: true, grantEdit: true, grantDel: true});
}

export function getSecBySecTask(appContext: IApplicationContext, taskCode: string, secType: SecType = SecType.Read) : boolean
{
  const secGrant = findSecurityTask(appContext, taskCode);

  switch (secType) {
    case SecType.Read: return secGrant?.grantRead ?? true; 
    case SecType.Add: return secGrant?.grantAdd ?? true; 
    case SecType.Edit: return secGrant?.grantEdit ?? true; 
    case SecType.Delete: return secGrant?.grantDel ?? true; 
    case SecType.YesOrNo: return secGrant?.grantYesNo ?? true; 
  }
}


export function removeDuplicatesByProperty(data: any[], property: keyof any): any {
  const seenValues = new Set();
  const dupValues = new Set();
  
  // add line/new line이 맨 위에 생기는 경우, 중복 된 항목은 맨 위의 항목 값을 지워야하므로,
  // foreach로 먼저 확인하게 함.
  data.forEach(item => {
    const value = item[property]?.toLowerCase();
    if (!seenValues.has(value)) {
      seenValues.add(value);
    }else{
      dupValues.add(value);
    }
  });

  return data.filter(item => {
    const value = item[property].toLowerCase();
    if (dupValues.has(value)) {
      dupValues.delete(value);
      return false;
    }
    return true;
  });
}


export function DevEncrypt2(sParams: string) {
  let key = 'DevPower EnCrypt by Steve Robbins';
  let utf8Encode = new TextEncoder();
  let k = 0;
  let keyChar = utf8Encode.encode(key);
  let result = "";
  let inputChar = utf8Encode.encode(sParams);

  for (var i = 0; i < inputChar.length; i++) {
    result += (inputChar[i] ^ keyChar[k++]).toString(16).toUpperCase().padStart(2, '0');
    if (k >= keyChar.length) k = 0;
  }

  return (inputChar.length * 2).toString().padStart(6, '0') + result;
}

export const stringArraysEqual = (arr1: string[], arr2: string[]) => {
  if (arr1.length !== arr2.length) return false;
  arr1.sort();
  arr2.sort();
  for (let i = 0; i < arr1.length; i++) {
    if (arr1[i] !== arr2[i]) return false;
  }
  return true;
};
